import React, { useState } from 'react';
import Header from './Header';
import UserFooter from './UserFooter';
import { sendMessage } from '../../service/ContactService';
import { useToast } from '../toast/ToastProvider';

const ContactUs = () => {

  const toast = useToast();
  

     const [formData, setFormData] = useState({
       name: "",
       email: "",
       mobileNo: "",
       message: "",
     });
  const [loading,setLoading]=useState(false)

     const handleChange = (e) => {
       const { name, value } = e.target;
       setFormData((prev) => ({ ...prev, [name]: value }));
     };

     const handleSendMessage = async (e) => {
       e.preventDefault();

       if (
         !formData.name ||
         !formData.email ||
         !formData.mobileNo ||
         !formData.message
       ) {
         toast("Please fill all fields", "ERROR");
         return;
       }
       setLoading(true);
       try {
           await sendMessage(formData);
           console.log(formData);
           
         toast("Message Sent Successfully", "SUCCESS");
         setFormData({ name: "", email: "", mobileNo: "", message: "" });
       } catch (error) {
         toast("Error sending message", "ERROR");
       } finally {
         setLoading(false)
       }
     };

    return (
      <>
        <div id="preloader">
          <div id="status">
            <img src="images/preloader.gif" id="preloader_image" alt="loader" />
          </div>
        </div>
        <a href="javascript:;" id="return-to-top">
          <i className="fas fa-angle-double-up"></i>
        </a>

        <Header />
        <div className="contact-main-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="sb-contact-section">
                  {/* <nav aria-label="breadcrumb">
                                    <h4>Contact Us</h4>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><a href="/index">Home</a></li>
                                        <li className="breadcrumb-item " aria-current="page">Contact Us</li>
                                    </ol>
                                </nav> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="form-main-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="social-media-section">
                  <section>
                    <span>
                      <i className="fas fa-phone"></i>
                    </span>
                    <div>
                      <h6>Phone</h6>
                      <p>04362-238 235 </p>
                    </div>
                  </section>
                  <section>
                    <span>
                      <i className="fas fa-envelope"></i>
                    </span>
                    <div>
                      <h6>Email</h6>
                      <p>healthcare@example.com</p>
                    </div>
                  </section>
                  <section>
                    <span>
                      <i className="fas fa-map-marker-alt"></i>
                    </span>
                    <div>
                      <h6>Address</h6>
                      <p>6th Cross, Arulananda Nagar, Thanjavur, India.</p>
                    </div>
                  </section>
                </div>
              </div>
              <div className="col-lg-8 col-md-12 col-sm-12 col-12">
                <div className="form-section">
                  <h6>Leave a Message</h6>
                  <div className="form-input plr-15">
                    <form onSubmit={handleSendMessage} className="row ">
                      <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                        <div className="input-group flex-nowrap mt-4">
                          <input
                            type="text"
                            className="form-control "
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            placeholder="Name"
                          />
                          <span
                            className="input-group-text"
                            id="addon-wrapping1"
                          >
                            <i className="fas fa-user"></i>
                          </span>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                        <div className="input-group flex-nowrap mt-4">
                          <input
                            type="email"
                            className="form-control "
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            data-valid="email"
                            data-error="Email should be valid."
                            placeholder="Email"
                          />
                          <span
                            className="input-group-text"
                            id="addon-wrapping2"
                          >
                            <i className="fas fa-envelope"></i>
                          </span>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                        <div className="input-group flex-nowrap mt-4">
                          <input
                            type="number"
                            className="form-control "
                            name="mobileNo"
                            value={formData.mobileNo}
                            onChange={handleChange}
                            required
                            placeholder="Mobile Number"
                          />
                          <span
                            className="input-group-text"
                            id="addon-wrapping2"
                          >
                            <i className="fas fa-phone"></i>
                          </span>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <textarea
                          className="form-control mt-4 ps-3 required"
                          rows="4"
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          required
                          placeholder="Enter your message"
                        ></textarea>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="tb_es_btn_div">
                          <div className="response center"></div>
                          <input
                            type="hidden"
                            name="form_type"
                            value="contact"
                          />
                          <div className=" ">
                            <button
                              type="submit"
                              className="submitForm button-btn mt-4 d-flex align-items-center gap-2"
                              disabled={loading}
                            >
                              {loading ? (
                                <>
                                  <span>
                                    <i className="fas fa-paper-plane"></i>
                                  </span>
                                  Sending...
                                </>
                              ) : (
                                <>
                                  Send Message
                                  <span>
                                    <i className="fas fa-angle-double-right"></i>
                                  </span>
                                </>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="map-area">
          <div className="container-fluid">
            <div className="row">
              <div>
                <iframe
                  height="600"
                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4752.90177893092!2d79.13724977156274!3d10.787517692197072!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baab97d3b69e98b%3A0x8b74729f0e7fead!2sThanjavur%20Bus%20stand!5e1!3m2!1sen!2sin!4v1752312831980!5m2!1sen!2sin" 
                ></iframe>
                <a href="https://www.maps.ie/draw-radius-circle-map/"></a>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="footer-main-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="sb-footer-section">
                                <div className="footer-logo">
                                    <img src="images/footer-logo.png" alt="img" />
                                </div>
                                <ul>
                                    <li><a href="javascript:;"><i className="fas fa-map-marker-alt"></i>ADDRESS<br />
                                        121 Waldeck Street, NY, USA</a>
                                    </li>
                                    <li><a href="javascript:;"><i className="fas fa-phone"></i>PHONE<br />
                                        0800-123456, 0800-123489</a>
                                    </li>
                                    <li><a href="javascript:;"><i className="fas fa-envelope"></i>EMAIL<br />
                                        medisch@example.com</a>
                                    </li>
                                    <li>
                                        <ul className="footer-media">
                                            <li><a href="javascript:;"><i className="fab fa-facebook-f"></i></a></li>
                                            <li><a href="javascript:;"><i className="fab fa-twitter"></i></a></li>
                                            <li><a href="javascript:;"><i className="fab fa-instagram"></i></a></li>
                                            <li><a href="javascript:;"><i className="fab fa-pinterest-p"></i></a></li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6 col-sm-12 col-12">
                            <div className="links">
                                <h4>Useful Links</h4>
                                <ul>
                                    <li><a href="/about-us"><i className="fas fa-angle-right"></i>About Us</a></li>
                                    <li><a href="/service"><i className="fas fa-angle-right"></i>Service</a></li>
                                    <li><a href="/gallery"><i className="fas fa-angle-right"></i>Gallery</a></li>
                                    <li><a href="/blog-single"><i className="fas fa-angle-right"></i>Blog</a></li>
                                    <li><a href="/appoinment"><i className="fas fa-angle-right"></i>Appoinments</a></li>
                                    <li><a href="/contactUs"><i className="fas fa-angle-right"></i>Contact Us</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                            <h4>Recent Posts</h4>
                            <div className="img-link">
                                <ul>
                                    <li>
                                        <img src="images/post-img1.jpg" alt="img" />
                                        <div className="content">
                                            <h5 className="pb-0"><a href="/blog-single">Best Surgery</a></h5>
                                            <p>Our best surgery<br />
                                                available here.
                                            </p>
                                        </div>
                                    </li>
                                    <li>
                                        <img src="images/post-img2.jpg" alt="img" />
                                        <div className="content">
                                            <h5 className="pb-0"><a href="/blog-single">Best Doctors</a></h5>
                                            <p>Our best surgery<br />
                                                available here.
                                            </p>
                                        </div>
                                    </li>
                                    <li>
                                        <img src="images/post-img3.jpg" alt="img" />
                                        <div className="content">
                                            <h5 className="pb-0"><a href="/blog-single">Best Services</a></h5>
                                            <p>Our best surgery<br />
                                                available here.
                                            </p>
                                        </div>
                                    </li>
                                    <li>
                                        <img src="images/post-img4.jpg" alt="img" />
                                        <div className="content">
                                            <h5 className="pb-0"><a href="/blog-single">Best Rooms</a></h5>
                                            <p>Our best surgery<br />
                                                available here.
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="time-wrapper">
                                <div>
                                    <h4>Days</h4>
                                    <ul>
                                        <li>Monday</li>
                                        <li>Tuesday</li>
                                        <li>Wednesday</li>
                                        <li>Thrusday</li>
                                        <li>Friday</li>
                                        <li>Saturday</li>
                                        <li>Sunday</li>
                                    </ul>
                                </div>
                                <div>
                                    <h4>Opening Hours</h4>
                                    <ul>
                                        <li>08.00 - 10.00</li>
                                        <li>09.00 - 11.00</li>
                                        <li>10.00 - 12.00</li>
                                        <li>11.00 - 01.00</li>
                                        <li>12.00 - 02.00</li>
                                        <li>01.00 - 02.00</li>
                                        <li>02.00 - 04.00</li>
                                    </ul>
                                </div>
                            </div>
                            <div id="newsletter">
                                <h5>Sign Up for Newsletter</h5>
                                <div className="input-box">
                                    <input type="text" name="text" id="text" placeholder="Enter Your Email" />
                                    <a href="javascript:;">
                                        <i className="fas fa-paper-plane"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <section>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                <p>© Copyright 2022 - 23 Design by <a href="https://webstrot.com/">Webstrot</a>  | All Rights Reserved.</p>
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                <p className="last-para">Private Policy | Terms and Conditions.</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div> */}

        <UserFooter />
      </>
    );
};

export default ContactUs;